import { call, put, select, delay } from 'redux-saga/effects';
import { callWithAuth } from '../../sagaApiHelper';
import { getWabaIdsApi } from '../../../api/apiLists/getWabaIdsApi';
import { setWabaAccounts, setWabaLoading, setWabaError, setIsConnected } from '../../whatsappSlice';
import { getWabaIdsFromStorage, saveWabaIdsToStorage } from '../../../utils/apiCacheHelper';

export function* handleFetchWabaIds(action) {
  const { poll = false, force = false } = action.payload || {};

  const maxPolls = 20;
  const pollInterval = 3000;

  if (!poll && !force) {
    const wabaAccounts = yield select(state => state.whatsapp.wabaAccounts);
    
    if (Array.isArray(wabaAccounts) && wabaAccounts.length > 0) {
      yield put(setIsConnected(true));
      yield put({ type: 'FETCH_PHONES' });
      return;
    }
  }

  for (let attempt = 0; attempt < (poll ? maxPolls : 1); attempt++) {
    try {
      yield put(setWabaLoading(true));
      yield put(setWabaError(null));

      const companyInfo = yield select(state => state.companyInfo?.info || {});
      const companyId = yield select(state => state.auth?.user?.companyId || companyInfo?.companyId || companyInfo?.id || '');

      if (!companyId) {
        yield put(setWabaError('Company ID not found'));
        yield put(setWabaLoading(false));
        return;
      }

      const cachedAccounts = getWabaIdsFromStorage(companyId);
      if (cachedAccounts) {
        yield put(setWabaAccounts(cachedAccounts));
        yield put(setIsConnected(Array.isArray(cachedAccounts) && cachedAccounts.length > 0));
        yield put(setWabaLoading(false));
        if (Array.isArray(cachedAccounts) && cachedAccounts.length > 0) {
          yield put({ type: 'FETCH_PHONES' });
        }
        return;
      }

      const channelReq = {
        operation: 'GETWABAIDS',
        payload: { companyId }
      };

      const channelRes = yield call(callWithAuth, getWabaIdsApi, channelReq);

      let accounts = [];
      if (channelRes && (channelRes.status === true || channelRes.status === 'success' || channelRes.status === 'ok' || channelRes.success === true)) {
        const data = channelRes.data || channelRes || {};
        accounts = Array.isArray(data?.result?.data) ? data.result.data : [];

        if (accounts.length > 0) {
          if (accounts[0]?.wabaId) {
            sessionStorage.setItem('waba_id', accounts[0].wabaId);
          }
          saveWabaIdsToStorage(accounts, companyId);
        }
      }

      yield put(setWabaAccounts(accounts));
      yield put(setIsConnected(Array.isArray(accounts) && accounts.length > 0));

      if (Array.isArray(accounts) && accounts.length > 0) {
        yield put({ type: 'FETCH_PHONES', payload: { poll } });

        if (poll) {
          break;
        }
      } else if (poll && attempt < maxPolls - 1) {
        yield delay(pollInterval);
        continue;
      }
    } catch (error) {
      console.error('Error fetching WABA IDs:', error);
      yield put(setWabaError('Error occurred while fetching WABA IDs'));
      if (poll && attempt < maxPolls - 1) {
        yield delay(pollInterval);
        continue;
      }
    } finally {
      yield put(setWabaLoading(false));
    }

    if (!poll) {
      break;
    }
  }
}
